<template>
    <div class="enter_hs" style="width: 100%;">
    <div v-if="!moreStatus">
        <div :style="{backgroundImage: 'url('+beijing2+')'}" style="padding-top:60px;width:100%;background-position: center center;background-repeat: no-repeat;background-size: cover;">
            <div style="background:rgba(63, 168, 199, 0.1);padding:20px 30px 80px 30px;width:73%;font-size:16px;margin: 0 auto;">
                <div class="solve head-label just_center" style="padding-top: 20px;">
                    <img style="width:34px;" src="../assets/sangang1.png" >
                    <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:700;" class="font_size_24">
                        公司简介
                    </div>
                    <img style="width:34px;" src="../assets/sangang2.png" >
                </div>
                <div style="text-align:center;margin-top:35px;font-size:16px;">江苏苏豪汇升私募基金管理有限公司成立于2006年8月，注册资本5亿元。</div>
                <div style="margin-top:20px;text-align:center;margin-top:15px;font-size:16px;">苏豪汇升自成立以来，重点布局量化投资及资产配置业务，积极打造投资者的资产定制服务平台。</div>
                <div style="margin-top:25px;text-align:center;">
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                    <img style="width:32px;" src="../assets/juxing1.png"/>
                    <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                </div>
                <div style="text-align:center;margin-top:25px;font-size:16px;">公司团队成员近60名，硕士及以上学历占比超80%，均毕业于国内外一流院校，包括哥伦比亚大学、悉尼大学、清华大学、南京大学、上海</div>
                <div style="margin-top:20px;text-align:center;margin-top:15px;font-size:16px;">交大、同济大学等国内外一流院校。核心管理团队均具备10年以上投资管理经验，拥有丰富的量化投资实践积累和资产配置投资运营经验。</div>
                <div style="margin-top:25px;text-align:center;">
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                    <img style="width:32px;" src="../assets/juxing1.png"/>
                    <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                </div>
                <div style="text-align:center;margin-top:25px;font-size:16px;">苏豪汇升系江苏省属大型国有独资企业苏豪控股集团旗下的专业资产管理平台。</div>
                <div style="margin-top:20px;text-align:center;margin-top:15px;font-size:16px;">
                    苏豪控股集团合并报表企业数量超380户，员工超2万人，总资产和年营收均达千亿规模，是华泰证券、紫金银行、紫金保险、弘业期货等多家金融机构的股东，
                </div>
                <div style="margin-top:20px;text-align:center;margin-top:15px;font-size:16px;">
                    拥有境内外重要金融业务牌照，为产业链上下游提供多维度、特色化的交易平台与金融服务，重点服务江苏在“一带一路”，沿线国家的贸易和投资需求，
                </div>
                <div style="margin-top:20px;text-align:center;margin-top:15px;font-size:16px;">
                    集团控股汇鸿集团、江苏舜天、苏豪弘业、弘业期货和通用股份五家上市公司。
                </div>
            </div>
        </div>
    
        <div class="solve head-label just_center" style="padding-top: 120px;">
            <img style="width:34px;" src="../assets/sangang1.png" >
            <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:700;" class="font_size_24">
                发展历程
            </div>
            <img style="width:34px;" src="../assets/sangang2.png" >
        </div>
        <!-- <div style="font-size:24px;font-weight:600;text-align:center;padding:30px;">发展历程</div> -->
        <div style="width:100%;padding-top: 90px;">
            <div style="display:flex;width:90%;margin: 0 auto;margin-bottom: 15px;font-size:42px;font-weight:600;">
                <div style="width:33%;text-align:center;">{{dateLineData[0].date}}</div>
                <div style="width:33%;text-align:center;">{{dateLineData[1].date}}</div>
                <div style="width:33%;text-align:center;">{{dateLineData[2].date}}</div>
            </div>
            <div style="width:100%;height:1px;background:#999999;margin-top:25px;position:relative;">
                <img style="width:30px;position:absolute;top:-15px;right:10%;cursor:pointer;" @click="handleTo" :src="toSrc" >
                <img style="width:30px;position:absolute;top:-16px;left:10%;cursor:pointer;" @click="handleFrom" :src="fromSrc" >
            </div>
            <div style="display:flex;width:90%;margin: 0 auto;margin-top: 25px;">
                <div style="width:33%;text-align:center;font-size:16px;">
                    <span style="color:#3fa8c7;font-size:27px;font-weight:700;">{{dateLineData[0].title}}</span>
                    <div style="font-size:16px;line-height:28px;margin:0 auto;text-align:center;width:66%;margin-top:10px;">
                        {{dateLineData[0].content}}
                    </div>
                </div>
                <div style="width:33%;text-align:center;font-size:16px;">
                    <span style="color:#3fa8c7;font-size:27px;font-weight:700;">{{dateLineData[1].title}}</span>
                    <div style="margin:0 auto;line-height:28px;text-align:center;width:66%;margin-top:10px;">
                        {{dateLineData[1].content}}
                    </div>
                </div>
                <div style="width:33%;text-align:center;font-size:16px;">
                    <span style="color:#3fa8c7;font-size:27px;font-weight:700;">{{dateLineData[2].title}}</span>
                    <div style="margin:0 auto;line-height:28px;text-align:center;width:66%;margin-top:10px;">
                        {{dateLineData[2].content}}
                    </div>
                </div>
            </div>
        </div>

        <div class="solve head-label just_center" style="padding-top: 100px;">
            <img style="width:34px;" src="../assets/sangang1.png" >
            <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:700;" class="font_size_24">
                公司荣誉
            </div>
            <img style="width:34px;" src="../assets/sangang2.png" >
        </div>
        <!-- <div style="font-size:32px;font-weight:600;text-align:center;padding-top:50px;margin-bottom:-20px;">公司荣誉</div> -->
        <div style="position:relative;margin-top:30px;margin-bottom: 140px;">
            <!-- <carousel-3d
                :autoplay="true"
                :dir="ltr"
                :autoplayTimeout="3000"
                :perspective="35"
                :display="3"
                :border="0"
                :animationSpeed="1000"
                :width="500"
                :height="300"
                :inverseScaling="100"
                :controlsVisible="false"
                :controlsHeight="60"
            >
                <slide v-for="(item, i) in slides" :index="i" :key="i">
                <template>
                    <img :src="item.src" />
                </template>
                </slide>
            </carousel-3d> -->
            <img style="width:100%;" src="../assets/juanmahua.png" >
            <!-- <div style="position:absolute;top:150px;left:46%;transform: translateX(-42%);text-align: center;">
                <img style="width:47%;display:inline-block;" src="../assets/rongyu1.jpg" >
                <img style="width:47%;display:inline-block;margin-left:3%;" src="../assets/rongyu2.jpg" >
            </div> -->
            <!-- <div style="position:absolute;top:130px;left:50%;transform: translateX(-50%);text-align: center;">
                <img style="width:75%;" src="../assets/rongyu3.jpg" >
            </div> -->
            <div style="position:absolute;top:100px;width:100%;text-align: center;">
                <img style="height: 330px;display:inline-block;" src="../assets/rongyu6.jpg" >
                <img style="height: 330px;display:inline-block;" src="../assets/rongyu1.jpg" >
            </div>
            <div style="position:absolute;top:455px;width:100%;text-align: center;">
                <img style="height: 300px;display:inline-block;" src="../assets/rongyu7.jpg" >
                <img style="height: 300px;display:inline-block;" src="../assets/rongyu5.jpg" >
            </div>
        </div>

        <div style="width:62%;margin:0 auto;margin-top:-50px;height:330px;padding:5px;overflow-y: scroll;font-family:Microsoft YaHei;font-size: 16px;" class="scroller">
            <div class="m-timeline-area" style="width:91%;">
                <!-- :style="`width: ${width}px`" -->
                <div class="m-timeline">
                <div
                    :class="['m-timeline-item', {'last': index === timelineDesc.length - 1}]"
                    v-for="(desc, index) in timelineDesc"
                    :key="index">
                    <div class="u-tail"></div>
                    <div class="u-dot">
                        <div style="width:2px;height:2px;border-radius:1px;background:#69abb9;"></div>
                    </div>
                    <div class="u-content">
                        <div style="width:120px;font-size: 16px;color:#3fa8c7;">{{ desc.time || '--' }}</div>
                        <div style="flex:1;margin-left:20px;color: #5a5858;font-size: 16px;">
                            <img src="../assets/shijianjiedian.png" style="margin-right:10px;vertical-align:text-top;" />{{desc.name}}
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <div class="head-label just_center" style="padding-top: 130px;">
            <img style="width:34px;" src="../assets/sangang1.png" >
            <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:700;" class="font_size_24">
                汇升动态
            </div>
            <img style="width:34px;" src="../assets/sangang2.png" >
        </div>
        <div style="margin: 0 auto;margin-top:33px;width: 160px;height:46px;border-radius:23px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
            <div @click="handleMore" style="font-size:15px;font-weight:600;text-align:center;border-radius:20px;background:#3fa8c7;color:#ffffff;width:150px;height:40px;line-height:40px;cursor:pointer;">全部动态
                <img style="vertical-align: middle;" src="../assets/jiantou.png"/>
            </div>
        </div>

        <!-- <div style="font-size:24px;font-weight:600;text-align:center;padding:30px;">汇升动态</div>
        <div style="margin: 0 auto;width: 160px;height:50px;border-radius:25px;border:1px solid #92dded;justify-content: center;display: flex;align-items: center;">
            <div style="font-size:14px;font-weight:600;text-align:center;border-radius:18px;background:#45ceeb;color:#ffffff;width:130px;height:36px;line-height:36px;">全部动态 ——</div>
        </div> -->

        <div style="width:90%;margin:0 auto;margin-top:58px;padding-bottom:100px;display:flex;justify-content: space-around;">
            <!-- trends -->
            <div style="width:25%;height:auto;cursor:pointer;position:relative;overflow:hidden;display: flex;justify-content: center;align-items: center;" v-for="(item) in trends0" :key="item.imgId" @click="jumpWX(item)">
                 <!-- :class="{'hasIndex': index === 0}" -->
                <img style="width:100%;" :src="getImgUrl(item.imgId)"/>
                <div style="position: absolute;width: 100%;top:0;left:0;height: 100%;background: linear-gradient(to right, #003c82, #46434c);opacity: .3;"></div>
                <div style="position:absolute;top:45%;left:50%;transform: translate(-50%, -50%);color:#ffffff;font-size:16px;">{{item.title}}</div>
                <div style="clear:both;"></div>
            </div>
            <!-- <img style="width:25%;" src="../assets/huishengdongtai2.jpg"/>
            <img style="width:25%;" src="../assets/huishengdongtai3.jpg"/> -->
        </div>

        <div style="padding-top:60px;width:100%;background-position: center center;background-repeat: no-repeat;background-size: cover; padding-bottom: 25px;">
            <div style="padding:20px 30px 80px 30px;width:73%;font-size:16px;margin: 0 auto;">
                <div class="solve head-label just_center" style="padding-top: 20px;">
                    <img style="width:34px;" src="../assets/sangang1.png" >
                    <div style="text-align: center;margin-left:20px;margin-right:20px;font-size:32px;font-weight:700;" class="font_size_24">
                        联系方式
                    </div>
                    <img style="width:34px;" src="../assets/sangang2.png" >
                </div>
                <div styles="margin: 0 auto;margin-top:33px;width: 160px;height:46px;border-radius:23px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div style="text-align:center;margin-top:25px;font-size:19px;">联系电话: 025-86828106</div>
                    <div style="text-align:center;margin-top:15px;font-size:19px;">监督/举报/投诉邮箱: hsxf@highhope.com</div>
                    <div style="margin-top:20px;text-align:center;margin-top:15px;font-size:19px;">公司地址: 江苏省南京市秦淮区户部街15号兴业大厦21楼</div>
                </div>
            </div>
        </div>

      </div>
      <div v-if="moreStatus" style="width:82%;margin: 0 auto;padding-top:40px;">
        <div style="position:relative;font-size: 32px;font-weight:600;padding-bottom:15px;border-bottom: 1px solid #92dded;">
            汇升动态
            <img style="width:34px;margin-left:8px;" src="../assets/sangang2.png" >

            <div style="position:absolute;right:20px;top:5px;">
                <img style="width:32px;" src="../assets/juxing3.png"/>
                <img style="width:32px;" src="../assets/juxing1.png"/>
                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                <img style="width:32px;" src="../assets/juxing3.png"/>
            </div>
        </div>
        <div style="display: flex;margin-top:20px;border-bottom:1px solid #e8eaed;padding-bottom:18px;cursor:pointer;" v-for="item in trends" @click="jumpWX(item)" :key="item">
            <div style="width:30%;">
                <img style="width:90%;" :src="getImgUrl(item.imgId)"/>
            </div>
            <div style="width:70%;">
                <div style="font-size:23px;font-weight:600;margin-top:15px;">
                    {{item.title}}
                </div>
                <div style="font-size:16px;color:#3fa8c7;margin-top:15px;">发布于：{{item.createdTime}}</div>
                <div style="font-size:16px;margin-top:30px;">{{item.content}}</div>
            </div>
        </div>
        <el-pagination
            style="margin-top:15px;text-align:center;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout=" prev, pager, next"
            :total="totalNum">
        </el-pagination>
      </div>
    </div>
</template>
<script>
import { articleList } from '@/api/index'
import { Carousel3d, Slide } from 'vue-carousel-3d'
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                toSrc: require('../assets/youjiantou0.png'),
                beijing2: require('../assets/beijing2.png'),
                fromSrc: require('../assets/zuojiantou.png'),
                dialogVisible: false,
                moreStatus: false,
                width: 600,
                slides: [
                    {
                    title: 'parent1',
                    slide: 1,
                    src: require("../assets/rongyu1.jpg"),
                    videoSrc: '荣誉1' // require("../assets/风控合规-1.mp4")
                    },
                    {
                    title: 'parent2',
                    slide: 2,
                    src: require("../assets/rongyu3.jpg"),
                    videoSrc: '荣誉2' // require("../assets/风控合规-2.mp4")
                    },
                    {
                    title: 'parent3',
                    slide: 3,
                    src: require("../assets/rongyu2.jpg"),
                    videoSrc: '荣誉3' // require("../assets/风控合规-3.mp4")
                    }
                ],
                dateLineData: [{
                    title: '多元化投资布局',
                    content: '根据市场变化给予投资的不同机会，丰富投资品种，尝试股权、PE、地产基金等多元价值型投资。',
                    date: '2010-2012'
                }, {
                    title: '聚焦量化投研体系打造',
                    content: '自建量化团队，从单一策略逐步构建以“量化+”为核心的多策略体系，积累核心量化投研能力',
                    date: '2013-2016'
                }, {
                    title: '从量化到“资产配置+量化”',
                    content: '基于深厚的量化基因，传承10年大类资产配置积累的资源和经验，以“量化投资+资产配置”，打造投资者的资产定制服务平台。',
                    date: '2017-至今'
                }],
                // [{
                //     title: '从量化到“资产配置+量化”',
                //     content: '基于深厚的量化基因，传承10年大类资产配置积累的资源和经验，以“量化投资+资产配置”，打造投资者的资产定制服务平台。',
                //     date: '2017-至今'
                // }, {
                //     title: '聚焦量化投研体系打造',
                //     content: '自建量化团队，从单一策略逐步构建以“量化+”为核心的多策略体系，积累核心量化投研能力',
                //     date: '2013-2016'
                // }, {
                //     title: '多元化投资布局',
                //     content: '根据市场变化给予投资的不同机会，丰富投资品种，尝试股权、PE、地产基金等多元价值型投资。',
                //     date: '2010-2012'
                // }, {
                //     title: '自营投资起步',
                //     content: '以上市公司自有资金管理为起点，专注于定增及二级投资，逐步探索公司特色的投资之路。',
                //     date: '2006-2009'
                // }]
                trends: [],
                trends0: [],
                locationUrl: 'http://www.hhhstz.com' + '/website_service/img/preview/',
                timelineDesc: [{
                    time: '2025年05月',
                    name: '荣获第八届“Wind最强私募”2024年度“组合基金最强私募”奖项。'
                }, {
                    time: '2024年07月',
                    name: '荣获第十五届“中国私募金牛奖”、“金牛私募管理公司（组合基金）”奖项。'
                }, {
                    time: '2024年07月',
                    name: '荣获第九届中国证券私募基金英华奖“三年期FOF策略”奖项。'
                }, {
                    time: '2024年05月',
                    name: '荣获“第十六届基金与财富管理·介甫奖”、“优秀母基金管理人”、“优秀FOF产品”两项大奖。'
                }, {
                    time: '2024年02月',
                    name: '荣获第十八届私募金排奖稳健卓越私募基金管理人（组合基金策略）奖项。'
                }, {
                    time: '2024年01月',
                    name: '荣获朝阳永续2023年风云榜一年期十强、五年期十强两项荣誉奖项。'
                }, {
                    time: '2024年01月',
                    name: '荣获2023年度“Wind最强私募”、“一年期组合基金最强私募”、“五年期套利策略最强私募”、“五年期组合基金最强私募”三项大奖。'
                }, {
                    time: '2023年03月',
                    name: '荣获（第十七届）私募排排网组合基金策略“最值得信赖私募基金管理人”。'
                }, {
                    time: '2023年01月',
                    name: '在Wind最强私募榜单评选中，荣获“一年期最强私募基金公司-组合基金策略”、“三年期最强私募基金公司-组合基金策略”、“五年期最强私募基金-套利策略”、“五年期最强私募基金-组合基金策略”四项大奖。'
                }, {
                    time: '2022年04月',
                    name: '荣获（第十六届）私募排排网组合基金策略“最值得信赖私募基金管理人”。'
                }, {
                    time: '2021年11月',
                    name: '荣获中国基金报2021英华奖三年期混合策略最佳产品奖。'
                }, {
                    time: '2020年10月',
                    name: '荣获中国基金报2020英华奖中国私募基金人气奖，旗下产品“汇升共盈一号”荣获一年期量化多头策略最佳产品奖。'
                }, {
                    time: '2020年01月',
                    name: '汇升期权一号产品获得金长江奖“绝对回报私募基金产品”。'
                }, {
                    time: '2019年09月',
                    name: '公司荣获中国基金报英华奖“量化对冲策略最佳产品奖”。'
                }, {
                    time: '2019年01月',
                    name: '在2018年东方财富私募风云榜中荣获“最具创新力基金公司”。'
                }, {
                    time: '2017年11月',
                    name: '公司荣获第二届私募基金金亿奖“2017年最佳事件驱动策略奖”。'
                }, {
                    time: '2016年03月',
                    name: '在私募排排网主办的“第十届私募基金高峰论坛”上，荣获“2015年度最佳相对价值策略私募基金”和“2015年度最佳事件驱动策略私募基金”两项奖项。'
                }, {
                    time: '2015年12月',
                    name: '在中国对冲基金年会上，荣获“最佳套利策略对冲基金奖”和“最佳对冲基金管理人奖”两项殊荣。'
                }],
                titles: [{
                    name: '首页',
                    value: '/index'
                }, {
                    name: '走进汇升',
                    value: '/enterHS'
                }, {
                    name: '汇升文化',
                    value: '/hsCulture'
                }, {
                    name: '汇升投教',
                    value: '/hsInvestEducation'
                }, {
                    name: '汇升招聘',
                    value: '/hsEngage'
                }],
                currentPage: 1, //默认显示第一页
                pageSize: 5, //默认每页显示10条
                totalNum: 0, //总页数
                carousel_height: '550px',
            }
        },
        methods: {
            changeTitle(item) {
                this.$router.push({
                    path: item.value,
                    // query: {
                    //     id: this.roleId,
                    //     ids: this.checkList
                    // }
                })
            },
            handleTo() {
                this.toSrc = require('../assets/youjiantou0.png')
                this.fromSrc = require('../assets/zuojiantou.png')
                this.dateLineData = [{
                    title: '多元化投资布局',
                    content: '根据市场变化给予投资的不同机会，丰富投资品种，尝试股权、PE、地产基金等多元价值型投资。',
                    date: '2010-2012'
                }, {
                    title: '聚焦量化投研体系打造',
                    content: '自建量化团队，从单一策略逐步构建以“量化+”为核心的多策略体系，积累核心量化投研能力',
                    date: '2013-2016'
                }, {
                    title: '从量化到“资产配置+量化”',
                    content: '基于深厚的量化基因，传承10年大类资产配置积累的资源和经验，以“量化投资+资产配置”，打造投资者的资产定制服务平台。',
                    date: '2017-至今'
                }]
            },
            getImgUrl(id) {
                return this.locationUrl + id
            },
            jumpWX(item) {
                // console.log(item)
                if (item.linkUrl) {
                    // location.href = item.linkUrl
                    window.open(item.linkUrl, "_blank");
                }
            },
            handleFrom() {
                this.toSrc = require('../assets/youjiantou.png')
                this.fromSrc = require('../assets/zuojiantou0.png')
                this.dateLineData = [{
                    title: '自营投资起步',
                    content: '以上市公司自有资金管理为起点，专注于定增及二级投资，逐步探索公司特色的投资之路。',
                    date: '2006-2009'
                }, {
                    title: '多元化投资布局',
                    content: '根据市场变化给予投资的不同机会，丰富投资品种，尝试股权、PE、地产基金等多元价值型投资。',
                    date: '2010-2012'
                }, {
                    title: '聚焦量化投研体系打造',
                    content: '自建量化团队，从单一策略逐步构建以“量化+”为核心的多策略体系，积累核心量化投研能力',
                    date: '2013-2016'
                }]
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val; //动态改变
            },
            handleCurrentChange(val) {
                this.currentPage = val; //动态改变
                this.initData()

                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 10)
            },
            handleMore() {
                this.moreStatus = true
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 10)
            },
            initData() {
                articleList({
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                })
                .then(res => {
                    this.trends = res.data.records
                    
                    this.totalNum = res.data.sumCount
                })

                articleList({
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    focus: 1
                })
                .then(res => {
                    this.trends0 = res.data.records
                    // this.trends = res.data.records
                    // if (this.trends.length > 3) {
                    //     this.trends0 = this.trends.slice(0, 3)
                    // } else {
                    //     this.trends0 = this.trends
                    // }
                    
                    // this.totalNum = res.data.sumCount
                })
            }
        },
        mounted() {
            this.initData()
            setTimeout(() => {
                this.dialogVisible = true
            }, 100)

            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 10)
        },
        components: {
    　　　　Carousel3d,
    　　　　Slide
    　　},
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
        },
    }
</script>
<style scoped>
    .scroller::-webkit-scrollbar {
        width: 4px;
        background: #f2f3f5;
    }
    ::-webkit-scrollbar-thumb  
    { 
        
        border-radius: 3px;
        background: #7ce1ff;
    } 
    .m-timeline-area {
        margin: 0 auto;
    }
    .m-timeline .m-timeline-item {
        position: relative;
        padding-bottom: 20px;
    }
    .m-timeline .m-timeline-item .u-tail {
        position: absolute;
        top: 10px;
        left: 5px;
        height: calc(100% - 10px);
        border-left: 1px solid #7ce1ff;
    }
    .m-timeline .m-timeline-item .u-dot {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #69abb9;
        border-radius: 50%;
        justify-content: center;
        display: flex;
        align-items: center;
    }
    .m-timeline .m-timeline-item .u-content {
        position: relative;
        top: -6px;
        font-size: 15px;
        margin-left: 25px;
        word-break: break-all;
        word-wrap: break-word;
        color: #69abb9;
        display: flex;;
        line-height: 24px;
    }
    .m-timeline .last .u-tail {
        display: none;
    }


    .begin_header{
        margin: auto;
        width: 80%;
        height: 80px;
        padding-top: 20px;
        /*background: #F56C6C;*/
    }
    .logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .header-title{
        font-size: 1em;
    }
    #header-img{
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .head-label {
        display: flex;
        margin-top: 10px;
    }

    .just_center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>
<style>
.hasIndex {
    position: absolute;
    left:0;
    top:0;
}
.el-pagination .btn-next, .el-pagination .btn-prev {
    background: none !important;
}
.enter_hs .el-dialog, .el-pager li {
    background: none;
}
.font_size_24 {
    font-size: 32px;
}
.box {
    margin: 0 auto;
    position: relative;
    transform: translateY(25%);
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
.carousel-3d-container {
    margin: 0 !important;
}
.carousel-3d-slide {
    background: none !important;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>


// WEBPACK FOOTER //
// src/components/enterHS.vue